import React, { Suspense, useEffect, useState } from "react";
import { PlusButton } from "../../helper/ImageFormat";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import DeleteModel from "../../Components/DeleteModel";
import { deleteItem } from "../../utils/apiUtils";
import {
    ShippingRateModel,
    ShippingzoneModel,
} from "../../Model/Model";
import ShippingTable from "./ShippingTable";
import Breadcrumb from "../../helper/Breadcrumb";

const ShippingZone = () => {
    const [shippingZonedata, setshippingZonedata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [updatedata, setupdatedata] = useState(null);
    const [IsDeleting, setIsDeleting] = useState(false);
    const [IsDeletingshippingRate, setIsDeletingshippingRate] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState({});
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);
    const [shipingRateModalOpen, setshipingRateModalOpen] = useState(false);
    const [shippingRateEditingId, setshippingRateEditingId] = useState(null);
    const [shippingRateupdatedata, setshippingRateupdatedata] = useState(null);
    const [shippingRatedeleteItemId, setshippingRatedeleteItemId] = useState({});
    const [shippingRatedeleteModalOpen, setshippingRatedeleteModalOpen] =
        useState(false);

    const toggleExpand = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };

    const fetchApi = () => {
        fetchAllData("shipping/zone", setshippingZonedata, null, setLoading);
    };
    useEffect(() => {
        fetchApi();
    }, []);
    const toggleModal = () => {
        setModalOpen((prev) => !prev);
        setEditingId(false);
        setupdatedata(null);
    };
    const handleEditClick = (data) => {
        setEditingId(data.id);
        const { createdAt, id, updatedAt, isActive, ...otherData } = data;
        setupdatedata(otherData);
        setModalOpen(true);
    };
    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };
    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("shipping/zone", deleteItemId?.id, fetchApi);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (error) {
            return error;
        } finally {
            setIsDeleting(false);
        }
    };
    const handletoggleShippingRate = () => {
        setshipingRateModalOpen((prev) => !prev);
        setshippingRateEditingId(false);
        setshippingRateupdatedata(null);
    };
    const handleEditShippingRateClick = (data) => {
        setshippingRateEditingId(data.id);
        setshippingRateupdatedata(data);
        setshipingRateModalOpen(true);
    };
    const handleshippingRateDelete = async (data) => {
        setshippingRatedeleteItemId(data);
        setshippingRatedeleteModalOpen(true);
    };
    const confirmDeleteShippingRate = async () => {
        setIsDeletingshippingRate(true);
        try {
            const res = await deleteItem(
                "shipping/rate",
                shippingRatedeleteItemId,
                fetchApi
            );
            setshippingRatedeleteItemId({});
            setshippingRatedeleteModalOpen(null);
            return res;
        } catch (error) {
            return error;
        } finally {
            setIsDeletingshippingRate(false);
        }
    };

     const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Shipping Zones", path: "*" },
  ];
    return (
        <div className="content-wrapper">
            <div className="page-header mt-5">
                <h3 className="custom-page-title">Shipping Zones</h3>
                 <Breadcrumb items={breadcrumbdata} />
            </div>
            <div
                style={{
                    background: "#fff",
                    padding: "10px",
                    marginTop: "-20px",
                    display: "flex",
                    justifyContent: "flex-end",
                }}
            >
                <div style={{ display: "flex", gap: "20px" }}>
                    <PlusButton handleAdd={toggleModal} module={"shipping zone"} />
                </div>
            </div>

            <ShippingTable
                loading={loading}
                shippingZonedata={shippingZonedata}
                handleEditClick={handleEditClick}
                handleDelete={handleDelete}
                toggleExpand={toggleExpand}
                expandedRow={expandedRow}
                toggleModal={toggleModal}
                handletoggleShippingRate={handletoggleShippingRate}
                handleEditShippingRateClick={handleEditShippingRateClick}
                handleshippingRateDelete={handleshippingRateDelete}
            />

            <Suspense fallback={null}>
                {modalOpen && (
                    <ShippingzoneModel
                        modalOpen={modalOpen}
                        toggleModal={toggleModal}
                        editingId={editingId}
                        setEditingId={setEditingId}
                        setupdatedata={setupdatedata}
                        updatedata={updatedata}
                        fetchApi={fetchApi}
                    />
                )}
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                {shipingRateModalOpen && (
                    <ShippingRateModel
                        modalOpen={shipingRateModalOpen}
                        toggleModal={handletoggleShippingRate}
                        editingId={shippingRateEditingId}
                        setEditingId={setshippingRateEditingId}
                        setupdatedata={setupdatedata}
                        updatedata={shippingRateupdatedata}
                        fetchApi={fetchApi}
                        expandedRow={expandedRow}
                    />
                )}
            </Suspense>

            <Suspense fallback={<div>Loading...</div>}>
                {deleteModalOpen && (
                    <DeleteModel
                        deleteModalOpen={deleteModalOpen}
                        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                        onConfirm={confirmDelete}
                        itemName="Shipping Zone"
                        isDeleting={IsDeleting}
                    />
                )}
            </Suspense>

            <Suspense fallback={null}>
                {shippingRatedeleteModalOpen && (
                    <DeleteModel
                        deleteModalOpen={shippingRatedeleteModalOpen}
                        setDeleteModalOpen={() =>
                            setshippingRatedeleteModalOpen(!shippingRatedeleteModalOpen)
                        }
                        onConfirm={confirmDeleteShippingRate}
                        itemName="Shipping Rate"
                        isDeleting={IsDeletingshippingRate}
                    />
                )}
            </Suspense>
        </div>
    );
};

export default ShippingZone;
